import { firebaseAuth, post } from '@fable/api'
import { signInWithCustomToken } from 'firebase/auth'

export const getCustomToken = async (auth_token: string) =>
  await post('/auth/custom_token', { auth_token })

export const authWithCustomToken = async (token: string) =>
  await signInWithCustomToken(firebaseAuth, token)
